import { normalize } from 'normalizr'
import { Commit } from 'vuex'

import Invitation from '@/models/invitation'
import Passenger from '@/models/passenger'

import axios from '@/axios-module'
import notification from '@/notification'
import router from '@/router'
import { InvitationSchema } from '@/schemas/invitation'

interface State {
  invitation: Invitation | null
}

const initialState: State = {
  invitation: null,
}

export enum InvitePageActionTypes {
  GetInvitation = '[InvitePage] GetInvitation',
  ResolveInvitation = '[InvitePage] ResolveInvitation',
}

export enum InvitePageMutationTypes {
  GetInvitationSuccess = '[InvitePage] GetInvitationSuccess',
  GetInvitationFailure = '[InvitePage] GetInvitationFailure',
  ResolveInvitation = '[InvitePage] ResolveInvitation',
  ResolveInvitationSuccess = '[InvitePage] ResolveInvitationSuccess',
}

export default {
  state: initialState,
  getters: {
    getInvitationPagePassenger(state: State): Passenger | null {
      return state.invitation ? state.invitation.passenger : null
    },
    getInvitationPageInvitation(state: State): Invitation | null {
      return state.invitation
    },
  },
  actions: {
    async [InvitePageActionTypes.GetInvitation](
      { commit }: { commit: Commit },
      token: string,
    ) {
      try {
        const response = await axios.get(`/customer/invitations/${token}`)
        commit(
          InvitePageMutationTypes.GetInvitationSuccess,
          normalize(response.data, InvitationSchema),
        )
      } catch ({ response }) {
        const message = response.data.error
        notification(message, 'error')
        router.push({ path: '/' })
      }
    },
    async [InvitePageActionTypes.ResolveInvitation](
      { state, getters }: { state: State; getters: any },
      { redirectTo = '/', isNewCustomer = false },
    ) {
      if (state.invitation) {
        try {
          await axios.put(
            `/customer/accept_invitations/${state.invitation.autologinToken}`,
            { isNewCustomer },
          )
        } catch ({ response }) {
          let message = ''
          if (response.status === 403) {
            message = response.data.error
          } else {
            const customer = getters.getCustomerById(
              state.invitation.customerId,
            )
            message = `A passenger with this email address is already included in ${
              customer && customer.firstName
            }'s booking`
          }
          notification(message, 'error')
        }
        router.push({ path: redirectTo })
      }
    },
  },
  mutations: {
    [InvitePageMutationTypes.GetInvitationSuccess](
      state: State,
      normalizedInvitation: any,
    ) {
      const invitation =
        normalizedInvitation.entities.invitations[normalizedInvitation.result]
      invitation.customerId = invitation.customer
      invitation.invitedCustomerId = invitation.invitedCustomer

      state.invitation = invitation
    },
    [InvitePageMutationTypes.ResolveInvitationSuccess]() {
      return undefined
    },
  },
}
